import { Box, CounterBadge, Text, Tooltip } from '@wix/design-system';
import { useTranslation } from 'react-i18next';

import { DATA_HOOKS } from '../../../dataHooks';
import { SparklesIcon } from '../../../icons/SparklesIcon';
import { useStore } from '../../../zustand/stores';

import css from './index.module.scss';

interface CopilotButtonProps {
  onClick: () => void;
}

export const CopilotButton = ({ onClick }: CopilotButtonProps) => {
  const { t } = useTranslation();
  const { unreadMessagesCount } = useStore(state => state.copilotSlice);

  return (
    <div
      onClick={onClick}
      data-hook={DATA_HOOKS.COPILOT_BUTTON}
      className={css.copilotButton}
    >
      {unreadMessagesCount > 0 && (
        <CounterBadge className={css.counterBadge} skin="danger" size="small">
          {unreadMessagesCount}
        </CounterBadge>
      )}
      <Tooltip content={t('article-page.copilot.tooltip')} enterDelay={300} size="small" moveBy={{ y: 12 }}>
        <Box align="center" verticalAlign="middle" gap="12px">
          <Box className={css.iconContainer}>
            <SparklesIcon />
          </Box>
          <Text size="small">{t('article-page.copilot')}</Text>
        </Box>
      </Tooltip>
    </div>
  );
};
